import React, { FC } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { enableNewExperience } from "./experience";

// Destaque no topo do dashboard antigo convidando para a nova tela (teste controlado).
const TryNewExperienceBanner: FC = () => {
  const intl = useIntl();
  const history = useHistory();

  const goToNew = () => {
    enableNewExperience();
    history.push("/overview");
  };

  return (
    <div
      className="card mb-5 mb-xl-10"
      style={{ background: "linear-gradient(120deg, #dc239b 0%, #009ee2 100%)", border: "none" }}
    >
      <div className="card-body d-flex flex-wrap align-items-center justify-content-between gap-4 py-5">
        <div className="d-flex align-items-center gap-4">
          <span className="badge badge-light fw-bolder" style={{ color: "#dc239b" }}>
            {intl.formatMessage({ id: "overview.experience.badge", defaultMessage: "Novo" })}
          </span>
          <div className="text-white">
            <div className="fw-bolder fs-4">
              {intl.formatMessage({ id: "overview.experience.try-title", defaultMessage: "Conheça a nova tela principal" })}
            </div>
            <div className="fs-7 opacity-75">
              {intl.formatMessage({
                id: "overview.experience.try-subtitle",
                defaultMessage: "Insights, KPIs e NPS em uma visão única. Sua opinião ajuda a evoluir.",
              })}
            </div>
          </div>
        </div>
        <button type="button" className="btn btn-light fw-bold" onClick={goToNew}>
          {intl.formatMessage({ id: "overview.experience.try-cta", defaultMessage: "Ver nova experiência" })}
        </button>
      </div>
    </div>
  );
};

export default TryNewExperienceBanner;
